import React, { ChangeEvent, useEffect, useState } from 'react'
import CustomSelectWithSearch from '../CustomSelectWithSearch';
import CouponLoader from '../CouponLoader';
import {applySelectAll} from "./MarketDetails/configData";

/**
 * This component renders the content of the current selected tab
 * @param props 
 * @returns 
 */

function SKUGroupTABContent(props: {
    currentTabName: string,
    selectedOptions?: string[]
    handleChange?: (selectedItems: Array<string>, tabName: string) => void,
    currentSelectedValues?: Record<string,string|null|string[]>,
    getContent:(...args:any[])=>any,
    multiple?:boolean
}) {
    const { currentTabName, selectedOptions, handleChange, currentSelectedValues ,getContent ,multiple} = props
    const [content, setContent] = useState<Array<{label:string,value:string}>>([]);
    const [searchText, setSearchText] = useState<string>("");
    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const countOfListItem = currentTabName === "batchCode" ? 100 : undefined;

    async function getTabContent() {
        setSearchLoading(true)
        try {
            const data: {value:string,label:string}[] = await getContent(currentSelectedValues, currentTabName);
            if(data){
                setContent(data.sort());
            }
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }
    }

    const onSelect = async (selectedItems: string[]) => {
        handleChange && handleChange(selectedItems, currentTabName)
    }

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    }


    useEffect(() => {
        document.getElementById('custom-select-with-search-scrollable-div')?.scrollTo({top:0,behavior: 'smooth'});
        getTabContent();
        setSearchText('');
    }, [currentTabName])

    return (
            <CustomSelectWithSearch
                sort
                multiple={multiple || currentTabName === 'batchCode'}
                options={[...content]}
                label=''
                handleChange={onSelect}
                selectedOptions={selectedOptions ?? []}
                handleSearch={handleSearch}
                ListComponentProps={{
                    style: { height: '250px', overflow: 'scroll' }
                }}
                loading={searchLoading}
                showSelectedAsChip
                searchText={searchText}
                loadingIcon={<CouponLoader />}
                countOfListItem={countOfListItem}
                enableSelectAll={currentTabName !== "batchCode" && applySelectAll()}
            />
    )
}

export default SKUGroupTABContent